import styled from 'styled-components';

type ContainerProps = {
  darkOverlay?: number
  zIndex?: number
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  
  z-index: ${({ zIndex }: ContainerProps) => zIndex ? zIndex : -1};

  ${({ darkOverlay }: ContainerProps) => {
    if (darkOverlay)
      return `
        .dark-overlay {
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: ${darkOverlay};
        }
      `;
  }}

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

type Props = {
  src: string
  darkOverlay?: number
  zIndex?: number
}

const BgVideo = ({ src, darkOverlay, zIndex }: Props) => {
  return (
    <Container darkOverlay={darkOverlay} zIndex={zIndex}>
      <video width="100%" height="100%" autoPlay={true} loop={true} muted>
        <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
      </video>
      <div className='dark-overlay' />
    </Container>
  );
};

export default BgVideo;